<template>
	<b-card no-body>
		<b-card-header
			class="p-0"
			style="font-size: 1rem; font-weight: bolder"
			role="tab"
		>
			<b-button
				class="td-bg-blue"
				block
				v-b-toggle="'tabel-dinamis-selected-data-list-collapse'"
				@click="
					rotateHalf($event, 'tabel-dinamis-selected-data-list-collapse-icon')
				"
			>
				<b-row class="font-weight-bolder">
					<b-col class="text-light" align="left">
						<b-icon icon="cart2" /> Keranjang Data
					</b-col>
					<b-col align="right">
						<b-icon
							id="tabel-dinamis-selected-data-list-collapse-icon"
							class="text-white"
							icon="chevron-double-down"
						></b-icon>
					</b-col>
				</b-row>
			</b-button>
		</b-card-header>

		<b-collapse appear visible id="tabel-dinamis-selected-data-list-collapse">
			<b-card-body>
				<b-list-group v-if="selectedDataList.length > 0">
					<b-list-group-item
						:class="
							(choosenDataIdx === idx ? 'td-bg-blue text-white' : '') +
							' px-4 py-2'
						"
						v-for="(item, idx) in selectedDataList"
						:key="idx"
					>
						<b-row align-v="center">
							<b-col>
								<b-row>
									<b-col>{{ item.selectedDataset.name }}</b-col>
								</b-row>
								<b-row
									class="font-weight-bold"
									style="font-size: 0.75rem !important"
								>
									<b-col>
										<span
											class="td-text-hover-help"
											v-b-popover.hover.html="
												constructIndicatorList(item.selectedIndicator)
											"
											>({{ item.selectedIndicator.length }} Indikator</span
										>,
										<span
											class="td-text-hover-help"
											v-b-popover.hover="
												constructPeriodDataList(item.selectedPeriod)
											"
											>{{ item.selectedPeriod.length }} Periode</span
										>,
										<template v-for="(item2, idx2) in item.selectedDimension">
											<span
												class="td-text-hover-help"
												v-b-popover.hover="{
													customClass: 'popover-overflow-y',
													content: constructItemDimensionList(
														item2.selectedItemDimension
													),
													html: true,
												}"
												:key="idx2"
											>
												{{ item2.selectedItemDimension.length }}
												{{ capitalizeEachWord(item2.name) }}</span
											><template v-if="idx2 < item.selectedDimension.length - 1"
												>,</template
											> </template
										>)
									</b-col>
								</b-row>
							</b-col>
							<b-col class="text-right" cols="2">
								<b-button
									:class="
										choosenDataIdx === idx ? 'td-text-blue' : 'td-btn-blue'
									"
									small
									pill
									:variant="choosenDataIdx === idx ? 'light' : 'primary'"
									@click="showChoosenData(idx)"
									:disabled="isFinishProcessChoosenData === false"
								>
									Tampilkan
									<b-icon class="ml-2" icon="display" />
								</b-button>
							</b-col>
						</b-row>
					</b-list-group-item>
				</b-list-group>
			</b-card-body>
		</b-collapse>
	</b-card>
</template>

<!-- javascript section-->
<script>
//import js modules section
import utils from "../../../../../../utils/TabelDinamisUtils.js";

//local registration for output component
export default {
	name: "VisualizationDataCart",
	data() {
		return {
			tdBgColor: ["td-bg-teal", "td-bg-orange", "td-bg-green", "td-bg-blue"],
		};
	},
	props: ["choosenDataIdx", "isFinishProcessChoosenData", "selectedDataList"],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {},
	watch: {},
	methods: {
		constructIndicatorList: function (val) {
			let valSize = val.length;

			return val.reduce((res, item, idx) => {
				if (idx === valSize - 1) {
					return res + "<li class='mb-1'>" + item.name + "</li></ol>";
				} else {
					return res + "<li class='mb-1'>" + item.name + "</li>";
				}
			}, "<ol class='p-0 ml-3 my-0 mr-0' type='a'>");
		},

		constructPeriodDataList: function (val) {
			let valSize = val.length;

			return val.reduce((res, item, idx) => {
				if (idx === valSize - 1) {
					return res + item.periodName;
				} else {
					return res + item.periodName + ", ";
				}
			}, "");
		},

		constructItemDimensionList: function (val) {
			let i = 0;
			let valSize = val.length;

			return val.reduce((res, item, idx) => {
				let y =
					res +
					"<b-badge class='px-2 py-1 td-badge " +
					this.tdBgColor[i] +
					" text-light' >" +
					utils.capitalizeEachWord(item.name) +
					"</b-badge>";

				if (i === 3) {
					i = 0;
				} else {
					i++;
				}

				if (idx === valSize - 1) {
					return y + "</b-col></b-row>";
				} else {
					return y;
				}
			}, "<b-row><b-col class='my-1 w-100' style='text-align: justify !important; line-height: 1.5rem !important; display: flex; flex-wrap: wrap; gap: 0.4rem; font-size: 0.65rem; min-width: 0px; text-overflow: ellipsis;'>");
		},

		capitalizeEachWord(str) {
			return utils.capitalizeEachWord(str);
		},

		regionName: function (val) {
			switch (val) {
				case "NationalByProvince":
					return "Provinsi";

				case "ProvinceByDistrict":
					return "Kabupaten/Kota";

				case "DistrictBySubdistrict":
					return "Kecamatan";

				case "SubdistrictByVillage":
					return "Desa/Kelurahan";
			}
		},

		rotateHalf: function (event, id) {
			document.getElementById(id).classList.toggle("tabel-dinamis-rotate-half");
		},

		showChoosenData(idx) {
			setTimeout(
				function () {
					this.rotateHalf(
						null,
						"tabel-dinamis-selected-data-list-collapse-icon"
					);

					this.$root.$emit(
						"bv::toggle::collapse",
						"tabel-dinamis-selected-data-list-collapse"
					);

					this.$emit("update:choosenDataIdx", idx);
				}.bind(this),
				500
			);
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";

.tabel-dinamis-rotate-half {
	transform: rotate(180deg) !important;
}

#tabel-dinamis-selected-data-list-collapse-icon {
	transition: 0.5s;
	border: 1px solid transparent !important;
}

.popover-overflow-y {
	max-width: 50% !important;
	// max-height: 250px !important;
	overflow: auto !important;
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 15-09-2022 -->